require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _color = _interopRequireDefault(require("color"));

var _IconButton = _interopRequireDefault(require("./IconButton"));

var _Surface = _interopRequireDefault(require("./Surface"));

var _theming = require("../core/theming");

var _MaterialCommunityIcon = _interopRequireDefault(require("./MaterialCommunityIcon"));

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Searchbar.tsx";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Searchbar = function (_React$Component) {
  (0, _inherits2["default"])(Searchbar, _React$Component);

  function Searchbar() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Searchbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Searchbar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClearPress", function () {
      _this.clear();

      _this.props.onChangeText && _this.props.onChangeText('');
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "root", void 0);
    return _this;
  }

  (0, _createClass2["default"])(Searchbar, [{
    key: "setNativeProps",
    value: function setNativeProps(args) {
      return this.root && this.root.setNativeProps(args);
    }
  }, {
    key: "isFocused",
    value: function isFocused() {
      return this.root && this.root.isFocused();
    }
  }, {
    key: "clear",
    value: function clear() {
      return this.root && this.root.clear();
    }
  }, {
    key: "focus",
    value: function focus() {
      return this.root && this.root.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      return this.root && this.root.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          clearAccessibilityLabel = _this$props.clearAccessibilityLabel,
          clearIcon = _this$props.clearIcon,
          icon = _this$props.icon,
          customIconColor = _this$props.iconColor,
          inputStyle = _this$props.inputStyle,
          onIconPress = _this$props.onIconPress,
          placeholder = _this$props.placeholder,
          searchAccessibilityLabel = _this$props.searchAccessibilityLabel,
          style = _this$props.style,
          theme = _this$props.theme,
          value = _this$props.value,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["clearAccessibilityLabel", "clearIcon", "icon", "iconColor", "inputStyle", "onIconPress", "placeholder", "searchAccessibilityLabel", "style", "theme", "value"]);
      var colors = theme.colors,
          roundness = theme.roundness,
          dark = theme.dark,
          fonts = theme.fonts;
      var textColor = colors.text;
      var font = fonts.regular;
      var iconColor = customIconColor || (dark ? textColor : (0, _color["default"])(textColor).alpha(0.54).rgb().string());
      var rippleColor = (0, _color["default"])(textColor).alpha(0.32).rgb().string();
      return React.createElement(_Surface["default"], {
        style: [{
          borderRadius: roundness,
          elevation: 4
        }, styles.container, style],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 178
        }
      }, React.createElement(_IconButton["default"], {
        accessibilityTraits: "button",
        accessibilityComponentType: "button",
        accessibilityRole: "button",
        borderless: true,
        rippleColor: rippleColor,
        onPress: onIconPress,
        color: iconColor,
        icon: icon || function (_ref) {
          var size = _ref.size,
              color = _ref.color;
          return React.createElement(_MaterialCommunityIcon["default"], {
            name: "magnify",
            color: color,
            size: size,
            direction: _reactNative.I18nManager.isRTL ? 'rtl' : 'ltr',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 196
            }
          });
        },
        accessibilityLabel: searchAccessibilityLabel,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 185
        }
      }), React.createElement(_reactNative.TextInput, (0, _extends2["default"])({
        style: [styles.input, _objectSpread({
          color: textColor
        }, font), inputStyle],
        placeholder: placeholder || '',
        placeholderTextColor: colors.placeholder,
        selectionColor: colors.primary,
        underlineColorAndroid: "transparent",
        returnKeyType: "search",
        keyboardAppearance: dark ? 'dark' : 'light',
        accessibilityTraits: "search",
        accessibilityRole: "search",
        ref: function ref(c) {
          _this2.root = c;
        },
        value: value
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 206
        }
      })), React.createElement(_IconButton["default"], {
        borderless: true,
        disabled: !value,
        accessibilityLabel: clearAccessibilityLabel,
        color: value ? iconColor : 'rgba(255, 255, 255, 0)',
        rippleColor: rippleColor,
        onPress: this.handleClearPress,
        icon: clearIcon || function (_ref2) {
          var size = _ref2.size,
              color = _ref2.color;
          return React.createElement(_MaterialCommunityIcon["default"], {
            name: "close",
            color: color,
            size: size,
            direction: _reactNative.I18nManager.isRTL ? 'rtl' : 'ltr',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 232
            }
          });
        },
        accessibilityTraits: "button",
        accessibilityComponentType: "button",
        accessibilityRole: "button",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 222
        }
      }));
    }
  }]);
  return Searchbar;
}(React.Component);

(0, _defineProperty2["default"])(Searchbar, "defaultProps", {
  searchAccessibilityLabel: 'search',
  clearAccessibilityLabel: 'clear'
});

var styles = _reactNative.StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  input: {
    flex: 1,
    fontSize: 18,
    paddingLeft: 8,
    alignSelf: 'stretch',
    textAlign: _reactNative.I18nManager.isRTL ? 'right' : 'left',
    minWidth: 0
  }
});

var _default = (0, _theming.withTheme)(Searchbar);

exports["default"] = _default;